import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "maropost-app" }, {
    default: _withCtx(() => [
      _createCommentVNode(" Splash screen while bootstrap is in progress "),
      (!$setup.isAccountReady)
        ? (_openBlock(), _createBlock($setup["SplashScreen"], { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" Render resolved layout from route meta (defaults to AppLayout) "),
            (_openBlock(), _createBlock(_resolveDynamicComponent($setup.activeLayout)))
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }))
}